import constantCreator, { promiseStates } from '~/utils/constantsCreator';
import { optionsActivity, getActivityOptionsFromValues } from '~/utils/filter';
import api from '~/utils/api';

const constant = constantCreator.defineAction('filter').defineAction;
const GET_ACTIVITY = constant('GET_ACTIVITY', promiseStates);
const SET_FILTERINFO = constant('SET_FILTERINFO');
const LOG_USE_FILTER = constant('LOG_AVAILABLE_DATE_OPEN_CALENDAR');
const GET_ACTIVITY_BY_CITY = constant('GET_ACTIVITY_BY_CITY', promiseStates);
const GET_DEFAULT_ACTIVITY = constant('GET_DEFAULT_ACTIVITY');

const initialState = {
  filterInfo: {},
  isLoading: false,
  isError: false,
  activityInfo: null,
  activities: optionsActivity,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIVITY.PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case GET_ACTIVITY.RESOLVED: {
      return {
        ...state,
        isLoading: false,
        activityInfo: action.data
          .map(d => ({ ...d, _id: `rand-${Math.random().toString(36).substring(7)}` }))
      };
    }
    case GET_ACTIVITY.REJECTED: {
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    }
    case GET_ACTIVITY_BY_CITY.PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case GET_ACTIVITY_BY_CITY.RESOLVED: {
      return {
        ...state,
        isLoading: false,
        activities: getActivityOptionsFromValues(action.data),
      };
    }
    case GET_ACTIVITY_BY_CITY.REJECTED: {
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    }
    case SET_FILTERINFO:
      return {
        ...state,
        filterInfo: action.data
      };
    case GET_DEFAULT_ACTIVITY:
      return {
        ...state,
        activities: optionsActivity
      };
    default:
      return state;
  }
};

export default reducer;

export const actions = {
  getActivity: (city, activity) => ({
    type: GET_ACTIVITY,
    promise: api.get(`/info/trip-filter?activity=${activity}${city ? `&city=${city}` : ''}`)
  }),
  getActivityByCity: (city) => ({
    type: GET_ACTIVITY_BY_CITY,
    promise: api.get(`/info/trip-activity/${city}`)
  }),
  getDefaultActivity: () => ({
    type: GET_DEFAULT_ACTIVITY,
  }),
  setFilterInfo: (data) => ({
    type: SET_FILTERINFO,
    data
  }),
  logFilterActivity: (page, city, activity) =>({
    type: LOG_USE_FILTER,
    page,
    city,
    activity
  })
};

export const analytics = {
  [LOG_USE_FILTER]: action => ({
    name: action.page,
    category: 'filter',
    providers: 'database',
    city: action.city,
    activity: action.activity
  })
};
